export default function isEmpty(obj) {
  return Object.getOwnPropertyNames(obj).length < 1;
}



// WEBPACK FOOTER //
// ./utils/emptyObject.js